import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IGetTemplatePayload } from '@app-store/slices/dataImport/getTemplate'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: IGetTemplatePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.dataImport.getTemplate

function* getTemplateSagaTask({ payload }) {
    try {
        const response = yield axios.get(
            `/companies/imports/template?templateFor=${payload.templateFor}&addCategories=true`
        )
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload?.sagaCB?.onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getTemplateSaga(): any {
    yield takeLatest<TaskAction>(onRequest, getTemplateSagaTask)
}

export default getTemplateSaga
